export default {
	langs: {
		english: 'Anglais',
		french: 'Français'
	},
	login: {
		username: 'E-mail',
		password: 'Mot de passe',
		remember: 'Se souvenir de moi',
		login: 'Se connecter',
		logout: 'Se déconnecter',
		errUsrInvalid: 'Email non valide',
		errUsrMissing: 'Renseignez votre email',
		errPwdMissing: 'Renseignez votre mot de passe',
		errFormInvalid: 'Formulaire invalide'
	},
	network: {
		loading: 'Chargement',
		sending: 'Envoi'
	}
}



// WEBPACK FOOTER //
// ./src/locales/fr.js